module.exports = __webpack_public_path__ + "img/impress-rodape.34f461ef.png";